import React, { useEffect, useState } from "react";
import FormGrupo from './FormGrupo';
import { Grid, Button, Card } from '@material-ui/core';
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import ModalAbm from '../../compartidos/abms/ModalAbm';
import AlertaMail from '../../empadronamiento/UI/AlertaMail';
import BuscadorAbm from '../../compartidos/abms/BuscadorAbm';
import TableGeneric from '../../compartidos/abms/TableGeneric';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { AUTORIZACIONES_PRACTICAS_AGRUPADAS } from '../../../utils/permisos';
import AccionesGenericoAbm from '../../compartidos/abms/AccionesGenericoAbm';
import { 
  agregarGrupo, 
  buscarGrupo, 
  eliminarGrupo, 
  fetchGrupos, 
  modificarGrupo 
} from '../../../actions/autorizaciones/practicasAgrupadas';

const useStyles = makeStyles({
  botonera: {
    padding: 25
  }
});

export const HomePracticasAgrupadas = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  
  const { permisos: permisosUser } =  useSelector(state => state.auth)
  const { grupos: items } = useSelector((state) => state.practicasAgrupadas);
  
  const [item, setItem] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModalPregunta, setOpenModalPregunta] = useState(false);

  useEffect(() => {
    dispatch(fetchGrupos());
  }, [dispatch])

  const handleSearch = (textoBuscado) => {
    dispatch(buscarGrupo(textoBuscado));
  }

  const handlePatologiasSelectSelect = (item) => {
    setItem(item)
    setOpenModal(true)
  }

  const handleSave = (item) => {
    if (item.id) {
      dispatch(modificarGrupo(item.id, item));
    } else {      
      dispatch(agregarGrupo(item));
    }
  };

  const handleDecision = (decicion = false) => {    
    if(decicion){
      setOpenModalPregunta(false)
      handleDelete(item)
    }else{
      setOpenModalPregunta(false)
      setItem(null)
    }
  }

  const handleDelete = (item) => {
    dispatch(eliminarGrupo(item.id))
  }

  return (
      <Grid container justify="center">
        {!item
          ?
            <ModalAbm title="Agregar Grupo" open={openModal} setOpen={setOpenModal}>
              <FormGrupo 
                item={null} 
                handleSave={handleSave} 
                permisosUser={permisosUser} 
                cerrarModal={() => setOpenModal(false)} 
                permisoAlta={AUTORIZACIONES_PRACTICAS_AGRUPADAS.ALTA}
              />
            </ModalAbm>
          :
            <ModalAbm title="Modificar Grupo" open={openModal} setOpen={setOpenModal}>
              <FormGrupo 
                item={item} 
                handleSave={handleSave} 
                permisosUser={permisosUser} 
                cerrarModal={() => {setOpenModal(false); setItem(null);}} 
                permisoEdit={AUTORIZACIONES_PRACTICAS_AGRUPADAS.MODIFICACION}
              />
            </ModalAbm>
        }
        <Grid item xs={12}>
          <Button 
            color="primary" 
            variant="contained" 
            onClick={() => setOpenModal(true)} 
            style={{ float: "right", marginTop: "1rem" }}
            disabled={!validarSoloUnPermiso(permisosUser, AUTORIZACIONES_PRACTICAS_AGRUPADAS.ALTA)}
          >
            + Agregar Grupo
          </Button>
        </Grid>
        <Grid item xs={12} md={6} className={classes.root}>
          <BuscadorAbm title="Buscar Grupo" handleSearch={handleSearch} />
        </Grid>
        {openModalPregunta &&
          <AlertaMail
            open={openModalPregunta}
            setOpen={setOpenModalPregunta}
            mensaje={'Se va a eliminar el grupo, desea continuar?'}
            handleDecisionYes={() => handleDecision(true)}
            handleDecisionNo={handleDecision}
          />
        }
        <Grid item xs={12} md={9} style={{ marginTop: "2rem" }} >
          <Card>
            <TableGeneric
              data={items}
              align={"center"}
              columns={[
                {
                  label:"",
                  customBody:(item) => (
                    <AccionesGenericoAbm
                      item={item}
                      handleItemSelect={handlePatologiasSelectSelect}
                      permisoDelete={AUTORIZACIONES_PRACTICAS_AGRUPADAS.BAJA}
                      handleDelete={() => {
                        setItem(item)
                        setOpenModalPregunta(true)
                      }}
                    />
                  )
                },
                {
                  label: "Nombre",
                  id: "nombre",
                  sort: true
                }
              ]}
            />
          </Card>
        </Grid>
      </Grid>
  );

};
